import { BaseAuditLogService } from './base-audit-log-service.ts';
import type { IAuditLogService, TAuditMessageSegment } from './types.ts';

export class ClientInsuranceAuditLogService extends BaseAuditLogService implements IAuditLogService {
  public override get messageSegments(): TAuditMessageSegment[] {
    switch (this.auditLog.action) {
      case 'created':
        return this.actionMessageSegments('uploaded customer insurance');
      case 'updated':
        return this.actionMessageSegments('updated customer insurance validity period');
      case 'deleted':
        return this.actionMessageSegments('deleted customer insurance');
      default:
        return super.messageSegments;
    }
  }

  private actionMessageSegments(action: string): TAuditMessageSegment[] {
    return [this.text(this.actor), this.text(action)];
  }
}
